<template>
  <div>
    <div class="v-datatable__actions">
      <div class="v-datatable__actions__range-controls">
        <div class="v-datatable__actions__pagination">
          {{ currentPage * perPage - perPage + 1 }}-
          {{ currentPage * perPage }} of {{ total }}
        </div>
        <button
          type="button"
          class="v-btn v-btn--flat v-btn--icon theme--light"
          :class="{ 'v-btn--disabled': isInFirstPage }"
          aria-label="Previous page"
          :disabled="isInFirstPage"
          @click="onClickPreviousPage"
        >
          <div class="v-btn__content">
            <i aria-hidden="true" class="v-icon material-icons theme--light"
              >chevron_left</i
            >
          </div>
        </button>
        <button
          type="button"
          class="v-btn v-btn--flat v-btn--icon theme--light"
          :class="{ 'v-btn--disabled': isInLastPage }"
          aria-label="Next page"
          :disabled="isInLastPage"
          @click="onClickNextPage"
        >
          <div class="v-btn__content">
            <i aria-hidden="true" class="v-icon material-icons theme--light"
              >chevron_right</i
            >
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 3
    },
    totalPages: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    startPage() {
      if (this.currentPage === 1) {
        return 1;
      }

      if (this.currentPage === this.totalPages) {
        return this.totalPages - this.maxVisibleButtons + 1;
      }

      return this.currentPage - 1;
    },
    endPage() {
      return Math.min(
        this.startPage + this.maxVisibleButtons - 1,
        this.totalPages
      );
    },
    pages() {
      const range = [];

      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        });
      }

      return range;
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      return this.currentPage === this.totalPages;
    }
  },
  methods: {
    onClickFirstPage() {
      this.$emit("pagechanged", 1);
    },
    onClickPreviousPage() {
      this.$emit("pagechanged", this.currentPage - 1);
    },
    onClickPage(page) {
      this.$emit("pagechanged", page);
    },
    onClickNextPage() {
      this.$emit("pagechanged", this.currentPage + 1);
    },
    onClickLastPage() {
      this.$emit("pagechanged", this.totalPages);
    },
    isPageActive(page) {
      return this.currentPage === page;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// resources/js/components/insights/global/Pagination.vue